export const isAlphaNumeric = (value: string) => (value && /^[a-z0-9]+$/i.test(value) ? undefined : 'global.not_alpha_numeric')
